import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'
import { Info } from '@next-nx/shared-ui/icons'
import { Tooltip } from '@next-nx/shared-ui/atoms'
import styles from './ListIconBoxItem.module.sass'


interface Props {
  item: MenuItemType
  helpText?: string
  className?: string
  editMode?: boolean
}

const ListIconBoxItem = (props: Props) => {

  const { 
    item = undefined,
    className = '',
    editMode = false,
  } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      {!!getIcon(item.style) && <div className={styles.icon}>{getIcon(item.style)}</div>}
      <div className={styles.content}>
        {!!item.name && (
          editMode || (typeof item.name !== 'string')
          ? <div className={styles.title}>{item.name}</div>
          : <p className={styles.title}>{item.name}</p>
        )}
        {!!item.description && (
          <div className={styles.helper}>
            <Tooltip 
              id={`tooltip-listiconboxitem-${item.pk}`}
              label={item.description}
              pos="top"
            >
              <span className={styles.info}><Info /></span>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  ) : <></>
}

export default ListIconBoxItem
